import Images from "@/assets/Images";
import {
  BuildingLibraryIcon,
  BuildingStorefrontIcon,
  BuildingOffice2Icon,
  BuildingOfficeIcon,
  DocumentCheckIcon,
  DocumentMinusIcon,
  DocumentTextIcon,
  FolderIcon,
  HandThumbUpIcon,
  InboxArrowDownIcon,
  InboxIcon,
  MinusCircleIcon,
  ReceiptRefundIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";

import { CircleStackIcon, PercentBadgeIcon } from "@heroicons/react/24/solid";

const CLAIM_TYPE = [
  {
    id: 1,
    name: "Cashless",
    code: "cashless",
  },
  {
    id: 2,
    name: "Reimbursement",
    code: "reimbursement",
  },
];

const YES_NO = [
  {
    id: 1,
    name: "Yes",
    code: "yes",
  },
  {
    id: 2,
    name: "No",
    code: "no",
  },
];

const UPLOAD_DOCUMENTS_ARRAY = [
  {
    id: 1,
    name: "aadhar_card",
    label: "Aadhaar Card",
  },
  {
    id: 2,
    name: "pan_card",
    label: "PAN Card",
  },
  {
    id: 3,
    name: "diagnostic_report",
    label: "Diagnostic Reports",
  },
  {
    id: 4,
    name: "discharge_summary",
    label: "Discharge Summary",
  },
  {
    id: 5,
    name: "pharmacy_bill",
    label: "Pharmacy Bills",
  },

  {
    id: 6,
    name: "hospital_bill",
    label: "Hospital Bills & Receipts",
  },
  {
    id: 7,
    name: "bank_details",
    label: "Bank Details (for Reimbursement Claims)",
  },
];

const UPLOAD_HOME_DOCUMENTS = [
  {
    id: 1,
    name: "cancelled_cheque",
    label: "Cancelled Cheque",
  },
  {
    id: 2,
    name: "bank_details",
    label: "Bank Passbook Copy",
  },
];

const IMPORTANT_NOTES = [
  {
    id: 1,
    name: "Accepted formats: PDF, JPG, JPEG, PNG, ",
  },
  {
    id: 2,
    name: "Maximum file size: 10MB per document",
  },
  {
    id: 3,
    name: "Ensure all documents are clear and readable",
  },
  {
    id: 4,
    name: "Bank details are mandatory for reimbursement claims",
  },
];
const BASIC_FIELDS = [
  {
    label: "Certificate Number",
    accessKey: "certificate_number",
  },
  {
    label: "Claimant Name",
    accessKey: "claimant_name",
  },
  // {
  //   label: "Patient Name",
  //   accessKey: "patient_name",
  // },
  // {
  //   label: "Claim Type",
  //   accessKey: "claim_type",
  // },
  {
    label: "Insured Name",
    accessKey: "insured_name",
  },
  {
    label: "Total Claimed Amount",
    accessKey: "total_claimed_amount",
  },
  {
    label: "Claim Settlement Type",
    accessKey: "claim_settlement_type",
  },
];
const BASIC_DETAILS_VIEW_SCHEMA = [
  ...BASIC_FIELDS,
  {
    label: "Hospitalisation Reason",
    accessKey: "hospitalistaion_reason",
  },
];
const BASIC_DETAILS_IP_OPD_VIEW_SCHEMA = [
  ...BASIC_FIELDS,
  // {
  //   label: "Consultation Date",
  //   accessKey: "consultation_date",
  // },
];
const HOSPITAL_DETAILS_VIEW_SCHEMA = [
  {
    label: "Hospital Name",
    accessKey: "hospi_name",
  },
  {
    label: "Hospital Address",
    accessKey: "hospi_address",
  },
  {
    label: "Hospital Pincode",
    accessKey: "hospi_pincode",
  },
  {
    label: "Hospital  State",
    accessKey: "hospi_state",
  },
  {
    label: "Hospital City",
    accessKey: "hospi_city",
  },
  {
    label: "Nature of Illness",
    accessKey: "nature_of_illness",
  },

  {
    label: "Date of Admission",
    accessKey: "admitted_at",
  },
  {
    label: "Date of Discharge",
    accessKey: "discharged_at",
  },
  {
    label: "Cause of Hospitalization",
    accessKey: "hospitalisation_reason",
  },
  {
    label: "Expense Details",
    accessKey: "expense_details",
  },
];
const EMI_PROTECT_VIEW_SCHEMA = [
  {
    label: "Loan Account Number",
    accessKey: "loan_account_number",
  },
  {
    label: "EMI Amount",
    accessKey: "emi_amount",
  },
  {
    label: "Event Date",
    accessKey: "event_date",
  },
  {
    label: "Cause of Event",
    accessKey: "cause_of_event",
  },
  {
    label: "Claim Amount Requested",
    accessKey: "emi_claim_amount_requested",
  },
];
const PERSONAL_ACCIDENT_VIEW_SCHEMA = [
  {
    label: "Date Of Accident",
    accessKey: "accident_date",
  },
  {
    label: "Date Of Admission",
    accessKey: "admission_date",
  },
  {
    label: "Date Of Discharge",
    accessKey: "discharge_date",
  },
  {
    label: "Nature Of Injuries",
    accessKey: "nature_of_injuries",
  },
  {
    label: "Insured Profession",
    accessKey: "insured_profession",
  },
  {
    label: "Time Of Accident",
    accessKey: "accident_time",
  },
  {
    label: "Place Of Accident",
    accessKey: "accident_place",
  },
  {
    label: "Accident Related To Occupation",
    accessKey: "accident_related",
  },
  {
    label: "Claim Amount Requested",
    accessKey: "personal_accident_claim_amount_requested",
  },
  {
    label: "Reported To Police",
    accessKey: "reported_to_police",
  },
  {
    label: "Police Station Name",
    accessKey: "police_station_name",
  },
  {
    label: "Description Of Accident",
    accessKey: "accident_description",
  },
];
const LIFE_INSURANCE_VIEW_SCHEMA = [
  {
    label: "Date of Death",
    accessKey: "date_of_death",
  },
  {
    label: "Cause of Death",
    accessKey: "cause_of_death",
  },
  {
    label: "Death Certificate Number",
    accessKey: "death_certificate_number",
  },
  {
    label: "Claim Amount Requested",
    accessKey: "life_claim_amount_requested",
  },
];
const HEALTH_CLAIM_VIEW_SCHEMA = [
  {
    label: "Claim Type",
    accessKey: "type",
  },
  {
    label: "Hospital Name",
    accessKey: "hospital_name",
  },
  {
    label: "Hospital Address",
    accessKey: "hospital_address",
  },
  {
    label: "Diagnosis",
    accessKey: "diagnosis",
  },
  {
    label: "Hospital Pincode",
    accessKey: "hospital_pincode",
  },
  {
    label: "Hospital State",
    accessKey: "hospital_state",
  },
  {
    label: "Hospital City",
    accessKey: "hospital_city",
  },
  {
    label: "Proposed Date Of Admission",
    accessKey: "date_time_of_admission",
  },
  {
    label: "Date Of First Consultation",
    accessKey: "date_of_first_consultation",
  },
  {
    label: "Expected Date Of Discharge",
    accessKey: "date_time_of_discharge",
  },

  // Cashless flow
  {
    label: "Estimated Hospital Cost",
    accessKey: "estimated_hospital_cost",
  },
  {
    label: "Requested Cashless Amount",
    accessKey: "requested_cashless_amount",
  },

  // Reimbursement flow
  {
    label: "Total Hospital Bill Amount",
    accessKey: "total_hospital_bill_amount",
  },
  {
    label: "Claim Amount",
    accessKey: "claim_amount",
  },
  {
    label: "Deductible Amount",
    accessKey: "deductible_amount",
  },
  {
    label: "Co-payment",
    accessKey: "co_payment",
  },

  {
    label: "Nature Of Illness",
    accessKey: "nature_of_illness",
  },
  {
    label: "Treating Doctor Name",
    accessKey: "doctor_name",
  },
  {
    label: "Network Hospital",
    accessKey: "network_hospital",
  },
  {
    label: "Room Category",
    accessKey: "room_category",
  },
  {
    label: "ICU",
    accessKey: "icu",
  },
  {
    label: "Pre-Existing Disease",
    accessKey: "pre_existing_disease",
  },
  {
    label: "Disease",
    accessKey: "disease",
  },
];

const HOSPITAL_DETAILS_IP_OPD_VIEW_SCHEMA = [
  {
    label: "Hospital Name",
    accessKey: "hospi_name",
  },
  {
    label: "Hospital Address",
    accessKey: "hospi_address",
  },
  {
    label: "Hospital Pincode",
    accessKey: "hospi_pincode",
  },
  {
    label: "Hospital  State",
    accessKey: "hospi_state",
  },
  {
    label: "Hospital City",
    accessKey: "hospi_city",
  },
  {
    label: "Nature of Illness",
    accessKey: "nature_of_illness",
  },

  {
    label: "Date of Admission",
    accessKey: "admitted_at",
  },
  {
    label: "Date of Discharge",
    accessKey: "discharged_at",
  },
  {
    label: "Cause of Hospitalization",
    accessKey: "hospitalisation_reason",
  },
  {
    label: "Expense Details",
    accessKey: "expense_details",
  },
];

const INSURED_DETAILS_VIEW_SCHEMA = [
  {
    label: "Name of Insured",
    accessKey: "insured_name",
  },
  {
    label: "Contact number",
    accessKey: "insured_contact",
  },
  {
    label: "Address of correspondance",
    accessKey: "insured_address",
  },
  {
    label: "Name of property owner",
    accessKey: "owner_name",
  },
  {
    label: "Address of property owner",
    accessKey: "owner_address",
  },
];

const LOSS_DETAILS_VIEW_SCHEMA = [
  {
    label: "Date of Fire/Loss",
    accessKey: "fire_or_loss_at",
  },
  {
    label: "Cause of Fire/Loss",
    accessKey: "fire_or_loss_cause",
  },
  {
    label: "Items of policy affected",
    accessKey: "items_affected",
  },
  {
    label: "Occupation of Premises at Time of Fire/Loss",
    accessKey: "occupation_of_premises",
  },
  {
    label: "Has the Fire/Loss been reported to the Police?",
    accessKey: "has_reported_to_police",
  },
  {
    label: "Address where Loss can be Inspected",
    accessKey: "inspection_address",
  },
];

const PAYMENT_MODE_DETAILS_VIEW_SCHEMA = [
  {
    label: "Mode of Payment",
    accessKey: "payment_mode",
  },
];

const RAISE_CLAIM_TYPE = [
  {
    id: 1,
    name: "Raise Claim",
    code: "general",
    icon: Images?.RaiseClaim,
  },
  {
    id: 2,
    name: "Raise Claim IP/OPD",
    code: "ip_opd",
    icon: Images?.RaiseClaimIpOpd,
  },
];

const CLAIMS_PAYMENT_MODE = [
  {
    id: 1,
    name: "Cheque",
    code: "cheque",
  },
  {
    id: 2,
    name: "Fund Transfer",
    code: "fund_transfer",
  },
];

const FIELD_MAP: Record<string, string[]> = {
  // For health
  "claim-details": [
    "patient_name",
    "hospitalisation_reason",
    "admission_date_hospitalisation",
    "discharge_date_hospitalisation",
    "hospital_name",
    "nature_of_illness",
    "hospital_address",
    "hospital_pincode",
    "hospital_state",
    "hospital_city",
    "claim_type",
    "expenses_claimed_for",
    "total_claimed_amount",
    "claim_intimation_date",
    "consulted_at",
    "consultation_remarks",
    "add_expense",
    "planned_admitted_at",
    "date_time_of_admission",
    "date_time_of_discharge",
    "cause_of_hospitalization",
    "hospital_claim_amount_requested",
    "add_expense_details",
    "expense_details",
    "date_of_death",
    "cause_of_death",
    "death_certificate_number",
    "life_claim_amount_requested",
    "accident_date",
    "admission_date",
    "discharge_date",
    "nature_of_injuries",
    "insured_profession",
    "accident_time",
    "accident_place",
    "accident_related",
    "personal_accident_claim_amount_requested",
    "reported_to_police",
    "police_station_name",
    "accident_description",
    "loan_account_number",
    "emi_amount",
    "event_date",
    "cause_of_event",
    "emi_claim_amount_requested",
    "relationship",
    "total_claim_amount",
  ],
  "expense-details": ["expenses_details"],
  "upload-document": [
    "aadhar_card",
    "pan_card",
    "pharmacy_bill",
    "hospi_pharmacy_bill",
    "hospital_bill",
    "bank_details",
    "discharge_summary",
    "hospi_discharge_summary",
    "diagnostic_report",
    "hospi_diagnostic_report",
  ],
  // For Property
  "property-insured-details": [
    "name_insured",
    "contact_number",
    "property_owner_name",
    "property_owner_address",
    "correspondence_address",
  ],
  "property-loss-details": [
    "date_of_loss",
    "time_of_loss",
    "occupation_of_premises_at_loss_time",
    "loss_reported_police",
  ],
};

const CLAIM_FORM_NAVIGATION = ["claim-details", "upload-document"];

const FILE_FIELDS = [
  "aadhar_card",
  "pan_card",
  "diagnostic_report",
  "hospi_pharmacy_bill",
  "discharge_summary",
  "hospi_discharge_summary",
  "pharmacy_bill",
  "hospi_pharmacy_bill",
  "hospital_bill",
  "bank_details",
  "cancelled_cheque",
  "death_certificate",
  "post_mortem",
  "disability_certificate",
  "proof_of_event",
] as const;

const COLUMN_DROPDOWN_OPTIONS = [
  {
    id: 1,
    name: "Certificate no",
    code: "certificate.certificate_no",
  },
  {
    id: 2,
    name: "Segment",
    code: "segment_name",
  },
];
const CLAIM_TYPES_OPTIONS = [
  {
    id: 1,
    name: "Death",
    code: "death",
  },
  {
    id: 2,
    name: "Disability",
    code: "disability",
  },
  {
    id: 3,
    name: "Critical Illness",
    code: "critical-illness",
  },
  {
    id: 4,
    name: "Job Loss",
    code: "job_loss",
  },
];

const CLAIMS_CARDS_DATA: Record<string, { Icon: any; color: string }> = {
  Intimated: {
    Icon: InboxIcon,
    color: "text-primary bg-primary/20 rounded-full",
  },
  Acknowledged: {
    Icon: InboxArrowDownIcon,
    color: "text-secondary bg-secondary/10",
  },
  Assessment: {
    Icon: FolderIcon,
    color: "text-warning bg-warning/10",
  },
  Approved: {
    Icon: DocumentCheckIcon,
    color: "text-success bg-success/10",
  },
  Rejected: {
    Icon: DocumentMinusIcon,
    color: "text-error bg-error/10",
  },
  Processed: {
    Icon: DocumentTextIcon,
    color: "text-secondary bg-secondary/10",
  },
};

const CLAIM_DASHBOARD_ICON: Record<
  string,
  { id: number; Icon: any; color: string }
> = {
  Pending_Claims: {
    id: 1,
    Icon: MinusCircleIcon,
    color: "bg-purple-200 text-purple-500",
  },
  Total_Claims_Approved: {
    id: 2,
    Icon: HandThumbUpIcon,
    color: "bg-orange-200 text-orange-500",
  },
  Total_Claims_Rejected: {
    id: 3,
    Icon: ReceiptRefundIcon,
    color: "bg-red-200 text-red-500",
  },
};

const CLAIM_DASHBOARD_ICON_2: Record<
  string,
  {
    id: number;
    Icon: any;
    barColor: string;
    label: string;
    value: string;
    iconClass: string;
  }
> = {
  AVERAGE_CLAIM_TAT: {
    id: 1,
    Icon: CircleStackIcon,
    barColor: "bg-purple-900",
    label: "Average claim TAT",
    value: "08",
    iconClass: "text-yellow-500",
  },
  PENDING_FROM_PARTNER: {
    id: 3,
    Icon: ClockIcon,
    barColor: "bg-red-800",
    label: "Pending from partner",
    value: "2,798",
    iconClass: "text-orange-500",
  },
  AVERAGE_CLAIM_VALUE: {
    id: 4,
    Icon: PercentBadgeIcon,
    barColor: "bg-blue-800",
    label: "Average claim value",
    value: "₹54,580",
    iconClass: "text-blue-500",
  },
};
const stateCityData = [
  {
    id: 1,
    icon: BuildingLibraryIcon,
    city: "Mumbai",
    state: "Maharashtra",
    value: "1,250",
    iconClass: "text-blue-800",
  },
  {
    id: 2,
    icon: BuildingOffice2Icon,
    city: "Delhi",
    state: "Delhi",
    value: "1,180",
    iconClass: "text-green-800",
  },
  {
    id: 3,
    icon: BuildingOfficeIcon,
    city: "Karnataka",
    state: "Bangalore",
    value: "950",
    iconClass: "text-yellow-800",
  },
  {
    id: 4,
    icon: BuildingStorefrontIcon,
    city: "Hyderabad",
    state: "Telangana",
    value: "890",
    iconClass: "text-orange-700",
  },
  {
    id: 5,
    icon: BuildingLibraryIcon,
    city: "Chennai",
    state: "Tamil Nadu",
    value: "720",
    iconClass: "text-red-700",
  },
];
const NameStageData = [
  {
    id: 1,
    name: "Krishnakant Tiwari",
    role: "Insurance Provider",
    stage: "Stage-1",
    date: "23 June 2025",
    coiNumber: "COI53544545",
    stageColor: "bg-slate-300",
  },
  {
    id: 2,
    name: "Ananya Sharma",
    role: "Insurance Provider",
    stage: "Stage-2",
    date: "25 June 2025",
    coiNumber: "COI53544546",
    stageColor: "bg-red-300",
  },
  {
    id: 3,
    name: "Rohit Verma",
    role: "Insurance Provider",
    stage: "Stage-3",
    date: "28 June 2025",
    coiNumber: "COI53544547",
    stageColor: "bg-stone-300",
  },
  {
    id: 4,
    name: "Priya Singh",
    role: "Insurance Provider",
    stage: "Stage-1",
    date: "30 June 2025",
    coiNumber: "COI53544548",
    stageColor: " bg-orange-300",
  },
  {
    id: 5,
    name: "Amit Patel",
    role: "Insurance Provider",
    stage: "Stage-2",
    date: "02 July 2025",
    coiNumber: "COI53544549",
    // stageColor: "bg-slate-500",
  },
  {
    id: 6,
    name: "Sneha Gupta",
    role: "Insurance Provider",
    stage: "Stage-3",
    date: "05 July 2025",
    coiNumber: "COI53544550",
    stageColor: "bg-gray",
  },
  {
    id: 7,
    name: "Vikram Joshi",
    role: "Insurance Provider",
    stage: "Stage-1",
    date: "08 July 2025",
    coiNumber: "COI53544551",
    stageColor: "bg-red-300",
  },
];
const BarChartdata = [
  { month: "Jan", sales: 120 },
  { month: "Feb", sales: 90 },
  { month: "Mar", sales: 150 },
  { month: "Apr", sales: 150 },
  { month: "May", sales: 150 },
  { month: "Jun", sales: 150 },
  { month: "Jul", sales: 150 },
  { month: "Aug", sales: 150 },
  { month: "Sep", sales: 150 },
];
const CLAIM_HEALTH_BENEFIT_TYPE = [
  {
    id: 1,
    name: "Life",
    code: "life",
  },
  {
    id: 5,
    name: "Health",
    code: "health",
  },
  {
    id: 2,
    name: "PA",
    code: "personal_accident",
  },
  {
    id: 3,
    name: "Hospicash",
    code: "hospicash",
  },
  {
    id: 4,
    name: "EMI Protect",
    code: "emi_protect",
  },
];
const KYC_OPTIONS = [
  {
    id: 1,
    name: "Aadhar card",
    code: "aadhar_card",
  },
  {
    id: 2,
    name: "Pan card",
    code: "pan_card",
  },
];

const ROOM_CATEGORY = [
  {
    id: 1,
    name: "General Ward",
    code: "general_ward",
  },
  {
    id: 2,
    name: "Semi Private Room",
    code: "semi_private_room",
  },
  {
    id: 3,
    name: "Private Room",
    code: "private_room",
  },
  {
    id: 4,
    name: "ICU",
    code: "icu",
  },
];

const SEARCH_SELECTOR_FIELD = [
  "hospital_pincode",
  "hospital_state_id",
  "hospital_city_id",
  "claim_type_id",
  "claim_stage_id",
  "nature_of_damage",
  "authority_name",
];
const SELECTOR_FIELD = [
  "claimants_relationship_to_insured",
  "insured_person_marital_status",
  "account_type",
  "hospitalisation_due_to",
  "hospitalization_type",
  "nature_of_claim",
  "type_of_gadget",
  "country_of_purchase",
  "claim_type",
  "other_insurance",
  "reason_for_cancellation_interruption",
];

const YES_NO_FIELDS = [
  "was_the_insured_hospitalized",
  "was_it_a_pre_existing_condition",
  "was_it_reported_to_authorities",
  "was_it_reported_to_police_embassy",
  "has_the_sim_been_blocked",
  "has_the_imei_been_blacklisted",
  "has_any_repair_been_attempted",
  "is_the_device_covered_by_any_other_insurance",
  "are_you_claiming_from_the_other_insurer",
  "have_you_had_any_previous_claims_under_this_policy",
];
export {
  CLAIM_TYPES_OPTIONS,
  BarChartdata,
  NameStageData,
  stateCityData,
  CLAIM_DASHBOARD_ICON_2,
  CLAIM_DASHBOARD_ICON,
  BASIC_DETAILS_IP_OPD_VIEW_SCHEMA,
  BASIC_DETAILS_VIEW_SCHEMA,
  CLAIM_FORM_NAVIGATION,
  CLAIM_TYPE,
  CLAIMS_PAYMENT_MODE,
  FIELD_MAP,
  HOSPITAL_DETAILS_IP_OPD_VIEW_SCHEMA,
  HOSPITAL_DETAILS_VIEW_SCHEMA,
  IMPORTANT_NOTES,
  INSURED_DETAILS_VIEW_SCHEMA,
  LOSS_DETAILS_VIEW_SCHEMA,
  PAYMENT_MODE_DETAILS_VIEW_SCHEMA,
  RAISE_CLAIM_TYPE,
  UPLOAD_DOCUMENTS_ARRAY,
  UPLOAD_HOME_DOCUMENTS,
  YES_NO,
  FILE_FIELDS,
  COLUMN_DROPDOWN_OPTIONS,
  CLAIMS_CARDS_DATA,
  CLAIM_HEALTH_BENEFIT_TYPE,
  KYC_OPTIONS,
  ROOM_CATEGORY,
  EMI_PROTECT_VIEW_SCHEMA,
  PERSONAL_ACCIDENT_VIEW_SCHEMA,
  LIFE_INSURANCE_VIEW_SCHEMA,
  HEALTH_CLAIM_VIEW_SCHEMA,
  SEARCH_SELECTOR_FIELD,
  SELECTOR_FIELD,
  YES_NO_FIELDS,
};
